import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useLocation } from 'react-router-dom';
import { MenuItemProps, MenuItem as MenuItemMUI, Link } from '@ha/dsl';

const useStyles = makeStyles()(theme => ({
  menuItem: {
    color: theme.palette.grey[600],
    paddingInline: theme.spacing(2.5),

    '&.Mui-selected': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.grey[700],
    },
  },
}));

interface Props extends MenuItemProps {
  to?: string;
  rel?: string;
}

const MenuItem = React.forwardRef(
  ({ children, to, ...props }: Props, ref: React.RefObject<HTMLLIElement>) => {
    const { classes, cx } = useStyles();

    const { pathname } = useLocation();

    const componentProps = to
      ? {
          to,
          component: Link,
          kind: 'dark-blue',
          disableOutline: true,
          selected: props.selected ?? to === pathname,
        }
      : undefined;

    return (
      <MenuItemMUI
        {...props}
        {...componentProps}
        ref={ref}
        className={cx(classes.menuItem, props.className)}
      >
        {children}
      </MenuItemMUI>
    );
  },
);

export { MenuItem };
